(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["baron-vue-header-frontend"] = factory();
	else
		root["baron-vue-header-frontend"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (false) {}

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6d526186-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=69361c2e
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('Loader'), _c('v-app-bar', {
    style: {
      'background-color': _vm.themeColor,
      color: _vm.secondaryColor
    },
    attrs: {
      "app": "",
      "height": "75",
      "dark": ""
    }
  }, [_vm.companyObj ? _c('v-avatar', {
    staticClass: "mr-3",
    attrs: {
      "color": "grey lighten-5",
      "size": "70"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "max-height": "95%",
      "src": _vm.logo
    }
  })], 1) : _vm._e(), _vm.companyObj ? _c('v-toolbar-title', {
    staticClass: "font-weight-black headline hidden-sm-and-down",
    style: {
      'background-color': _vm.themeColor,
      color: _vm.secondaryColor
    }
  }, [_vm._v(" " + _vm._s(_vm.companyObj.schname ? _vm.companyObj.schname : _vm.companyObj.name) + " "), _c('br')]) : _vm._e(), _c('v-spacer'), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._l(_vm.menu, function (item, i) {
    return _c('span', {
      key: i + Math.random() + Math.random()
    }, [_c('v-btn', {
      style: {
        color: _vm.secondaryColor
      },
      attrs: {
        "text": "",
        "to": {
          name: item.route
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _c('span', [_vm._v(_vm._s(item.title))])], 1)], 1);
  }), _vm.authenticated ? _c('v-btn', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.signOut
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("mdi-logout-variant")]), _c('span', [_vm._v("Sign Out")])], 1) : _vm._e(), _vm.getStartedBtn ? _c('v-btn', {
    style: {
      color: _vm.secondaryColor,
      'background-color': _vm.getStartedBtnColor
    },
    attrs: {
      "rounded": ""
    },
    on: {
      "click": _vm.callGetStartedBtnMethod
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    },
    on: {
      "click": _vm.callGetStartedBtnMethod
    }
  }, [_vm._v("mdi-arrow-right")]), _c('span', [_vm._v(_vm._s(_vm.getStartedBtnLabel))])], 1) : _vm._e()], 2), _c('div', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-row', [_c('v-col', [_vm.getStartedBtn ? _c('v-btn', {
    staticClass: "mt-2",
    style: {
      color: _vm.secondaryColor,
      'background-color': _vm.getStartedBtnColor
    },
    attrs: {
      "rounded": ""
    },
    on: {
      "click": _vm.callGetStartedBtnMethod
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    },
    on: {
      "click": _vm.callGetStartedBtnMethod
    }
  }, [_vm._v("mdi-arrow-right")]), _c('span', [_vm._v(_vm._s(_vm.getStartedBtnLabel))])], 1) : _vm.companyObj ? _c('v-toolbar-title', {
    staticClass: "font-weight-black headline mt-3",
    style: {
      'background-color': _vm.themeColor,
      color: _vm.secondaryColor
    }
  }, [_vm._v(" " + _vm._s(_vm.companyObj.schname ? _vm.companyObj.schname.split(" ")[0] + " " + _vm.companyObj.schname.split(" ")[1] : _vm.companyObj.name.split(" ")[0] + " " + _vm.companyObj.name.split(" ")[1]) + " "), _c('br')]) : _vm._e()], 1), _c('v-col', [_c('v-menu', {
    attrs: {
      "transition": "slide-x-transition",
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": "",
            "fab": "",
            "dark": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-menu")])], 1)];
      }
    }])
  }, [_c('v-list', {
    style: {
      'background-color': _vm.themeColor,
      color: _vm.secondaryColor,
      opacity: 0.7
    }
  }, [_c('br'), _c('br'), _c('br'), _vm._l(_vm.menu, function (item, i) {
    return _c('v-layout', {
      key: i + Math.random() + Math.random(),
      staticClass: "justify-left"
    }, [_c('v-btn', {
      style: {
        color: _vm.secondaryColor,
        display: 'block'
      },
      attrs: {
        "text": "",
        "to": {
          name: item.route
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _c('span', [_vm._v(_vm._s(item.title))])], 1)], 1);
  }), _vm.authenticated ? _c('v-btn', {
    style: {
      color: _vm.secondaryColor,
      display: 'block'
    },
    attrs: {
      "text": "",
      "rounded": ""
    },
    on: {
      "click": _vm.signOut
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("mdi-logout-variant")]), _c('span', [_vm._v("Sign Out")])], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1)], 1)], 1)]);
};
var staticRenderFns = [];

// CONCATENATED MODULE: ./src/App.vue?vue&type=template&id=69361c2e

// CONCATENATED MODULE: ./src/main.js
/* harmony default export */ var main = ({
  async postDataWithToken(url, dataObj, token) {
    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(dataObj)
    });
    const data = await response.json();
    return data;
  },
  async postData(url, dataObj) {
    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(dataObj)
    });
    const data = await response.json();
    return data;
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"6d526186-vue-loader-template"}!./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Loader.vue?vue&type=template&id=53a83070
var Loadervue_type_template_id_53a83070_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": _vm.color,
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v(" Fetching data "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1);
};
var Loadervue_type_template_id_53a83070_staticRenderFns = [];

// CONCATENATED MODULE: ./src/components/Loader.vue?vue&type=template&id=53a83070

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Loader.vue?vue&type=script&lang=js
/* harmony default export */ var Loadervue_type_script_lang_js = ({
  props: {
    dialog: {
      default: false
    },
    color: {
      default: "green"
    }
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  }
});
// CONCATENATED MODULE: ./src/components/Loader.vue?vue&type=script&lang=js
 /* harmony default export */ var components_Loadervue_type_script_lang_js = (Loadervue_type_script_lang_js); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/Loader.vue





/* normalize component */

var component = normalizeComponent(
  components_Loadervue_type_script_lang_js,
  Loadervue_type_template_id_53a83070_render,
  Loadervue_type_template_id_53a83070_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Loader = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=script&lang=js


/* harmony default export */ var Appvue_type_script_lang_js = ({
  name: "HeaderComponentPackage",
  props: {
    getStartedBtn: {
      default: false
    },
    getStartedBtnColor: {
      default: "red"
    },
    getStartedBtnLabel: {
      default: "Get Started"
    },
    apiUrl: {
      default: null
    },
    themeColor: {
      default: "#FEFEFE"
    },
    secondaryColor: {
      default: "#FFF"
    },
    authenticated: {
      default: false
    },
    currentUser: {
      default: null
    },
    companyObj: {
      default: null
    },
    logoRoute: {
      default: null
    },
    signOutRoute: {
      default: "/auth/logout"
    },
    routes: {
      default: () => []
    },
    unAuthenticatedRoutes: {
      default: () => ["home", "school-website", "login", "register", "images-gallery", "reset-password", "resetting-password", "about-us", "contact-us", "gallery", "services", "donate-now", "pay-now", "pay-online", "online-store"]
    }
  },
  components: {
    Loader: Loader
  },
  data: () => ({
    menu: [],
    logo: "./logo-placeholder.png",
    routesThatRequireAuthentication: [],
    routesThatDoesNotRequireAuthentication: []
  }),
  async mounted() {
    this.filterRoutesBasedOnAuthentication();
    await this.getLogos(this.companyObj.emis);
  },
  methods: {
    filterRoutesBasedOnAuthentication() {
      this.routesThatRequireAuthentication = [];
      this.routesThatDoesNotRequireAuthentication = [];
      if (this.routes.length > 1) {
        this.routes.forEach(routeObj => {
          if (this.unAuthenticatedRoutes.includes(routeObj.route)) {
            this.routesThatDoesNotRequireAuthentication.push(routeObj);
          } else {
            if ((location.hostname.includes("docs-ai.co.za") || location.hostname.includes("172.20.10.4")) && routeObj.route.includes("switchboard")) {
              //do nothing
            } else {
              this.routesThatRequireAuthentication.push(routeObj);
            }
          }
        });
        this.selectRoutesBasedOnAuthentication(this.routesThatRequireAuthentication, this.routesThatDoesNotRequireAuthentication);
      }
    },
    selectRoutesBasedOnAuthentication(authRoutes, unauthRoutes) {
      if (this.authenticated) {
        this.menu = authRoutes;
      } else {
        this.menu = unauthRoutes;
      }
    },
    async getLogos(emis) {
      const images = await main.postData(this.apiUrl + this.logoRoute, {
        folder: "logos",
        emis: emis
      });
      if (images.length > 0) {
        this.logo = this.apiUrl + "/images/logos/" + this.companyObj.emis + "/" + images[0];
        this.$emit("get-logo", images[0]);
      }
    },
    async signOut() {
      const response = await main.postDataWithToken(this.apiUrl + this.signOutRoute, {}, localStorage.getItem("token"));
      if (response && response.loggedOut) {
        localStorage.clear();
        this.$emit("signedOut");
        location.reload();
      } else {
        alert("Oops, something went wrong!");
        return false;
      }
    },
    callGetStartedBtnMethod() {
      this.$emit("get-started-clicked");
    },
    notSameRoute() {
      if (window.location.pathname != "/") {
        return true;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/App.vue?vue&type=script&lang=js
 /* harmony default export */ var src_Appvue_type_script_lang_js = (Appvue_type_script_lang_js); 
// CONCATENATED MODULE: ./src/App.vue





/* normalize component */

var App_component = normalizeComponent(
  src_Appvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var App = (App_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (App);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=baron-vue-header-frontend.umd.js.map